import { usePumpSizing } from "../../../context/PumpSizingContext";
import { SavedResultIdBadge } from "./SavedResultIdBadge";
import { StartAgainButton } from "./StartAgainButton";

export function SavedResultsPanel() {
	const { savedSubmissionUuid, resultsSaved, saveResultsError } =
		usePumpSizing();

	if (saveResultsError) {
		return (
			<div className="pf-step__error" role="alert">
				<p>{saveResultsError}</p>
			</div>
		);
	}

	// Only confirms a save made here: loading by ID shows the header badge instead.
	if (!resultsSaved || !savedSubmissionUuid) {
		return null;
	}

	return (
		<div className="pf-saved-results" role="status">
			<h3 className="pf-saved-results__title">Results Saved</h3>
			<SavedResultIdBadge />
			<p className="pf-saved-results__note">
				This ID is how you will access these results in the future. Retain this
				ID for your reference.
			</p>
			<div className="pf-saved-results__actions">
				<StartAgainButton />
			</div>
		</div>
	);
}
